import { Form } from "react-bootstrap";

const UploadImage = ({title, getFile}) => {
    return (
        <Form.Group className="mb-3">
            <Form.Label>Upload {title}</Form.Label>
            <div style={{border: '2px dotted #48cae4'}} className="text-center p-3 rounded-2">
                <label className="d-flex flex-column" htmlFor="imageInput" >
                    <i style={{color:' #48cae4'}} class='bx bx-images fs-2'></i>
                    <span className="my-2">Drag your images here or <b style={{color:' #48cae4'}}>Browse</b></span>
                </label>
                <Form.Control style={{ display: 'none' }} type='file' id="imageInput" onChange={(e)=> getFile(e.target.files[0])} />
            </div>
        </Form.Group>
    );
}

export default UploadImage;